import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Linkedin, Instagram, Phone } from 'lucide-react';
import { Button } from './ui/button';

const AuthorBio = () => {
  const navigate = useNavigate();

  return (
    <div
      className="mt-16 bg-gray-900/60 border border-gold-500/20 rounded-2xl p-6 sm:p-8"
      data-testid="author-bio"
    >
      <div className="flex flex-col sm:flex-row gap-6 items-start">
        <img
          src="/images/portfolio/aryan-portrait.jpg"
          alt="Aryan Shivhare, Berlin-based digital marketer"
          className="w-24 h-24 rounded-full object-cover object-top border-2 border-gold-500/40 shrink-0"
          data-testid="author-bio-photo"
        />
        <div className="flex-1">
          <span className="text-xs text-gold-500 font-semibold tracking-widest uppercase">Written by</span>
          <h3 className="font-display text-2xl font-bold text-white mt-1 mb-3">Aryan Shivhare</h3>
          <p className="text-gray-300 leading-relaxed mb-5">
            Aryan is a Berlin-based, AI-driven digital marketer and content creator. He has managed
            €200K+ in paid social budgets across Meta and TikTok, grew Berlin Fashion Week&apos;s
            Instagram to 50K+ engaged followers, and delivered 150+ campaigns for European brands
            with an average 300% client ROI. He writes about performance marketing, SEO, and using
            AI to grow brands faster.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Button
              onClick={() => navigate('/contact')}
              className="bg-gold-500 hover:bg-gold-600 text-black font-semibold"
              data-testid="author-bio-cta"
            >
              Work with Aryan
            </Button>
            <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/in/aryan-shivhare-profile/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-gray-400 hover:text-gold-500 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/thisisaaryan__/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-gray-400 hover:text-gold-500 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://wa.me/491706684547"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="text-gray-400 hover:text-gold-500 transition-colors"
              >
                <Phone className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorBio;
